import(/* webpackMode: "eager" */ "/home/rajat/Downloads/HR Shakti/frontend/src/app/(public)/qa/page.tsx");
